import {useNavigate, useParams} from "react-router-dom";
import DashboardWideComponent from "@/components/DashboardWideComponent.tsx";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import CommonClass from "@/utils/common.ts";
import st from "@/styles/Banks.module.scss"
import DashboardClass from "@/utils/dashboard_class.ts";



const BankPage = () => {
    const {bank} = useParams()
    const all_banks = CMS.banks.repeater
    const online_payment = CMS.online_payment.repeater
    const e_payments = CMS.e_payments.repeater
    const stores = CMS.stores.repeater
    const all_payment_methods = [...all_banks, ...online_payment, ...e_payments, ...stores ]


    const navigate = useNavigate()
    const {i18n} = useTranslation()
    
    const getBank = () => {
        
        if(typeof all_payment_methods === "undefined" ||typeof bank === "undefined") return undefined
        
        let x = all_payment_methods.find((x) => x.label === bank)
        
        return CMS.langAwareFilter(x,  (i18n.language as LocalLanguage))
        
    }
    
    const bank_obj = getBank()
    
    useEffect(() => {
        if(window.innerWidth > CommonClass.breakpoints.breakpoint2) {
            navigate(DashboardClass.dashboard_routes.Banks)
        }
    }, [])
    
    return bank_obj && (
        <DashboardWideComponent
            
            heading={bank_obj.name}
            
            onBackClick={() => {
                navigate(-1)
            }}
            
            column_center = {
                <div className={st.bank_page_instr} dangerouslySetInnerHTML={{__html: bank_obj.instructions}} />
            }
        />
    )
}

export default BankPage